import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HhsgSharedAdminTab } from "../models";

@Injectable()
export class HhsgSharedTabControlService {    
    private reloadTabSource = new Subject<number>();
    public reloadTab$ = this.reloadTabSource.asObservable();

    private tabSource = new Subject<HhsgSharedAdminTab>();
    public tab$ = this.tabSource.asObservable();
    
    private tabFinishedLoadingSource = new Subject<number>();
    public tabFinishedLoading$ = this.tabFinishedLoadingSource.asObservable();

    private tabHiddenSource = new Subject<string>();
    public tabHidden$ = this.tabHiddenSource.asObservable();

    private tabLoadingSource = new Subject<number>();
    public tabLoading$ = this.tabLoadingSource.asObservable();

    private tabVisibleSource = new Subject<string>();
    public tabVisible$ = this.tabVisibleSource.asObservable();

    private tabSelectedSource = new Subject<string | number>();
    public tabSelected$ = this.tabSelectedSource.asObservable();

    private tabSelectedChangeSource = new Subject<string | number>();
    public tabSelectedChange$ = this.tabSelectedChangeSource.asObservable();

    public announceTabLoading(tabId: number): void {
        this.tabLoadingSource.next(tabId);
    }

    public announceTabFinishedLoading(tabId: number): void {
        this.tabFinishedLoadingSource.next(tabId);
    }

    public announceReloadTab(tabId: number): void {
        this.reloadTabSource.next(tabId);
    }

    public announceTab(tab: HhsgSharedAdminTab): void {
        this.tabSource.next(tab);
    }

    public announceTabHidden(tabName: string): void {
        this.tabHiddenSource.next(tabName);
    }

    public announceTabVisible(applicationAbbreviation: string): void {
        this.tabVisibleSource.next(applicationAbbreviation);
    }

    public announceSelectedTab(tabId: string | number): void {
        this.tabSelectedSource.next(tabId);
    }

    public announceSelectedTabChange(tabId: string | number): void {
        this.tabSelectedChangeSource.next(tabId);
    }
}